import { useLanguage } from "@/i18n/LanguageContext";
import { SectionHeading } from "@/components/SectionHeading";
import { FadeUp } from "@/components/motion/Reveal";

const ABOUT_IMAGE =
  "https://images.unsplash.com/photo-1618385455730-2571c38966b7?q=80&w=1200&auto=format&fit=crop";

export function About() {
  const { t } = useLanguage();

  return (
    <section id="ueber-uns" data-testid="about-section" className="blueprint-grid bg-[#FAFAFA] py-24 md:py-36">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <SectionHeading
          index={t.sections.about.index}
          label={t.sections.about.label}
          title={t.sections.about.title}
        />

        <div className="grid gap-12 lg:grid-cols-5 lg:gap-20">
          <div className="lg:col-span-3">
            <FadeUp>
              <p className="text-lg leading-relaxed text-navy md:text-xl">{t.about.p1}</p>
            </FadeUp>
            <FadeUp delay={0.1}>
              <p className="mt-6 text-base leading-relaxed text-muted-foreground md:text-lg">{t.about.p2}</p>
            </FadeUp>

            <FadeUp delay={0.2}>
              <div className="mt-10 flex flex-wrap gap-2.5" data-testid="about-chips">
                {t.about.chips.map((c, i) => (
                  <span
                    key={i}
                    className="border border-border bg-white px-4 py-2 text-sm font-medium text-navy transition-colors hover:border-brand hover:text-brand"
                  >
                    {c}
                  </span>
                ))}
              </div>
            </FadeUp>

            <FadeUp delay={0.25}>
              <div className="mt-12 inline-flex items-center gap-6 border border-border bg-white px-8 py-6">
                <span className="font-display text-3xl font-bold tracking-tight text-navy">100%</span>
                <span className="border-l border-border pl-6 text-sm text-muted-foreground">
                  {t.about.statValue}
                </span>
              </div>
            </FadeUp>
          </div>

          <FadeUp delay={0.15} className="lg:col-span-2">
            <div className="relative h-full min-h-[380px] overflow-hidden">
              <img
                src={ABOUT_IMAGE}
                alt="CAD / BIM planning"
                className="absolute inset-0 h-full w-full object-cover"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-navy/10" />
              <div className="absolute bottom-0 left-0 right-0 border-t border-white/20 bg-navy-deep/85 p-6 backdrop-blur-sm">
                <p className="font-mono text-xs uppercase tracking-[0.2em] text-white/60">CAD / BIM</p>
              </div>
            </div>
          </FadeUp>
        </div>
      </div>
    </section>
  );
}
